import { render, staticRenderFns } from "./not_open.vue?vue&type=template&id=31a7e25a&scoped=true&"
import script from "./not_open.vue?vue&type=script&lang=js&"
export * from "./not_open.vue?vue&type=script&lang=js&"
import style0 from "./not_open.vue?vue&type=style&index=0&id=31a7e25a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a7e25a",
  null
  
)

export default component.exports